function searchForFAQ(search_query) {
    $.ajax({
        type: 'POST',
        url: window.fpgmedia_js_params ? window.fpgmedia_js_params.ajaxurl : '/wp-admin/admin-ajax.php',
        data: {
          action: 'search_faq',
          search_query: search_query,
        },
        beforeSend: function() {
          $('.FAQ_FAQ').addClass('hasSearched');
          $('.FAQ_FAQ').html('<div>Söker efter "'+search_query+'" ...</div>');
        },
        success: function(response) {
          $('.FAQ_FAQ').html('');
          response.data.forEach(faq => {

            var html = '<div class="FAQ__item">';

              html += '<div class="FAQ__item--header">';
                html += '<div class="q">'+faq.q+'</div>';
                html += '<div class="icon"><span class="icon-icon">></span></div>';
              html += '</div>';

              html += '<div class="a">'+faq.a+'</div>';

            $('.FAQ_FAQ').append(html);
          });

          if (!response.data.length) {
            $('.FAQ_FAQ').append('<div class="no-results">Inga frågor matchade din sökning. Försök igen.</div>');
          }

        },
        error: function() {
          console.log('error.');
        },
    });
}

export default function() {
  $(document).on('click','.FAQ__Search .search-btn',function() {
    searchForFAQ($('input[name="faq-search"]').val());
  });

  var timerid;
  $('input[name="faq-search"]').on('input', function() {
    var search_query = $(this).val();
    if ($(this).data('lastval') != search_query) {

      $(this).data('lastval', search_query);
      clearTimeout(timerid);

      timerid = setTimeout(function() {
        searchForFAQ(search_query);
      }, 500);
    }
  });

  $(document).on('click','.FAQ__item--header',function() {
    $('.FAQ__item').removeClass('opened');
    var answer = $(this).parent().find('.a');
    var showing = answer.is(':visible');
    $('.a').slideUp(100);
    
    if (showing) {
      answer.slideUp(100);
    }
    else {
      answer.slideDown(100);
      $(this).parent().addClass('opened');
    }
      
  });
}


// WEBPACK FOOTER //
// ./scripts/components/faq.js